import { Platform } from 'react-native';
import { KeyboardSpacer } from '@betty/moonlight';
import { Screen } from '@betty/navigation';
import WithdrawLaunch from '../../components/WithdrawLaunch/WithdrawLaunch';

function WithdrawLaunchScreen() {
  return (
    <Screen paddingHorizontal="space-0">
      <WithdrawLaunch />
      {Platform.OS === 'android' ? <KeyboardSpacer /> : null}
    </Screen>
  );
}

export default WithdrawLaunchScreen;
